import { render, staticRenderFns } from "./PayInfoBox.vue?vue&type=template&id=509a9245&scoped=true"
import script from "./PayInfoBox.vue?vue&type=script&lang=js"
export * from "./PayInfoBox.vue?vue&type=script&lang=js"
import style0 from "./PayInfoBox.vue?vue&type=style&index=0&id=509a9245&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a9245",
  null
  
)

export default component.exports